import { useMatch } from "@tanstack/react-router";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { vehicleRecordQuery } from "@/app/Vehicles/GraphQL/vehicleRecordQuery";

export function useVehicleRecord() {
  const match = useMatch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/vehicles/$id",
  });

  const { data } = useSuspenseGqlQuery(vehicleRecordQuery, {
    id: match.params.id,
  });

  return data.vehicle;
}
